import { TrackerEvent, TrackerFactory, TrackerType } from './tracker-factory';

const beacon = TrackerFactory.create(TrackerType.Beacon);

export const sendBeaconEvent = (event: TrackerEvent) => {
  return beacon.report(event);
};
